import React from "react";

import { ColumnStyle } from "components/Common/TableStyle";

export const STEWARDS_COLUMNS = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    fixed: "left",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Email Address",
    dataIndex: "email_address",
    key: "email_address",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
];

export const STEWARDS_DATA = [
  {
    key: 1,
    name: "Debbie Data Steward",
    role: "Steward",
    phone: "(555) 555-1234",
    email_address: "debbie@fakemail.com",
  },
  {
    key: 2,
    name: "Don Data Steward",
    role: "Steward",
    phone: "(555) 555-2345",
    email_address: "don@fakemail.com",
  },
  {
    key: 3,
    name: "Doug Data Steward",
    role: "Steward",
    phone: "(555) 555-3456",
    email_address: "doug@fakemail.com",
  },
  {
    key: 4,
    name: "Andy App Steward",
    role: "Application Steward",
    phone: "(555) 555-4567",
    email_address: "andy@fakemail.com",
  },
  {
    key: 5,
    name: "Amy App Steward",
    role: "Application Steward",
    phone: "(555) 555-5678",
    email_address: "amy@fakemail.com",
  },
];
